import React from 'react';
import SingleServiceTwo from '../../components/Service/SingleServiceTwo';
import SectionTitle from '../../components/Common/SectionTitle';

// Service Image Icons (style2)
import mainIcon1 from '../../assets/img/service/style2/main-img/1.png';
import hoverIcon1 from '../../assets/img/service/style2/hover-img/1.png';
import mainIcon2 from '../../assets/img/service/style2/main-img/2.png';
import hoverIcon2 from '../../assets/img/service/style2/hover-img/2.png';
import mainIcon3 from '../../assets/img/service/style2/main-img/3.png';
import hoverIcon3 from '../../assets/img/service/style2/hover-img/3.png';
import mainIcon4 from '../../assets/img/service/style2/main-img/4.png';
import hoverIcon4 from '../../assets/img/service/style2/hover-img/4.png';
import mainIcon6 from '../../assets/img/service/style2/main-img/6.png';
import hoverIcon6 from '../../assets/img/service/style2/hover-img/6.png';

const ServiceIt = () => {
    return (
        <div id="rs-service-it" className="rs-services style3 pt-120 pb-120 md-pt-80 md-pb-80">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-44"
                    subtitleClass="sub-text"
                    subtitle="IT Services"
                    titleClass="title testi-title"
                    title="IT & Software Services"
                />
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item" prefix="01" mainIcon={mainIcon1} hoverIcon={hoverIcon1} Title="Software Development" serviceURL="software-development" Text="Custom software design, development and ongoing enhancements." />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item pink-bg" prefix="02" mainIcon={mainIcon2} hoverIcon={hoverIcon2} Title="Web & Mobile Development" serviceURL="web-development" Text="Modern web and mobile applications with user-centric design." />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item aqua-bg" prefix="03" mainIcon={mainIcon3} hoverIcon={hoverIcon3} Title="Analytic Solutions" serviceURL="analytic-solutions" Text="Analytics, reporting and data engineering to convert data into insight." />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item paste-bg" prefix="04" mainIcon={mainIcon4} hoverIcon={hoverIcon4} Title="Cloud & DevOps" serviceURL="cloud-and-devops" Text="CI/CD, cloud migrations and hybrid DevOps practices." />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo itemClass="services-item green-bg" prefix="05" mainIcon={mainIcon6} hoverIcon={hoverIcon6} Title="System Integration & Consulting" serviceURL="system-integration" Text="Seamless integration with third-party systems and enterprise applications." />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServiceIt;
